import { IconButton } from "@material-ui/core"
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate'
import { useCallback } from "react"
import { storage } from '../firebase/index'
import ImagePreview from './ImagePreview'

const ImageArea = (props) => {

    const images = props.images
    const image = props.image
    const setImages = props.setImages
    const setImage = props.setImage
    
    const uploadImage = useCallback( event => {
        const file = event.target.files
        let blob = new Blob(file, {type:'image/jpeg'})
        // 英数字16桁のファイル名をランダムで生成
        const S = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"
        const N = 16
        const fileName = Array.from(crypto.getRandomValues(new Uint32Array(N))).map((n)=>S[n%S.length]).join('')
        // アップロード先の設定
        const uploadRef = storage.ref('images').child(fileName)
        const uploadTask = uploadRef.put(blob)
    
        uploadTask.then(() => {
            uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                const newImage = {id: fileName, path: downloadURL} 
                if (setImages) {
                    setImages(prevState => prevState ? [...prevState, newImage] : [newImage])
                } else if (setImage) {
                    setImage(newImage)
                }
            })
        })
    }, [setImage,setImages]);

    const deleteImage = useCallback( async (id) => {
        const ret = window.confirm('この画像を削除しますか？')
        if (!ret) {
            return false
        } else {
            if (images) {
                const newImages = images.filter(image => image.id !== id)
                setImages(newImages)
            } else if (images) {
                const newImage = ""
                setImage(newImage)
            }
            return storage.ref('images').child(id).delete()
        }
    },[images,setImage,setImages])

    return (
        <div>
            <div>
                {images && (
                    images.map(image => <ImagePreview delete={deleteImage} id={image.id} path={image.path} key={image.id} />)
                )}
                {image && (
                    <ImagePreview delete={deleteImage} id={image.id} path={image.path} />
                )}
            </div>
            <IconButton style={{width: 48, height: 48, cursor: 'pointer'}}>
                <label style={{cursor: 'pointer'}}>
                    <input 
                        style={{display:'none'}} type='file' id='image' 
                        onChange={event => uploadImage(event)}
                    />
                    <AddPhotoAlternateIcon />
                </label>
            </IconButton>
            <label style={{cursor: 'pointer'}}>
                <span>画像を登録する</span>
            </label>
            
        </div>
    )
}
export default ImageArea